import React from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import NoData from "../../assets/Questions-bro.svg";
import { useMediaQuery } from "@mui/material";

const ForwardedAlreadyAnswered = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:1400px)");

  return (
    <Grid container spacing={3}>
      <>
        <Grid
          item
          xs={12}
          align="center"
          style={{ marginTop: isMobile && "160px" }}
        >
          {" "}
          <img
            src={NoData}
            alt="No Data"
            height={isMobile ? "300px" : "600px"}
          />
        </Grid>
        <Grid item xs={12} align="center">
          <Typography variant="title">{t("already_answered")}</Typography>
        </Grid>
      </>
    </Grid>
  );
};

export default ForwardedAlreadyAnswered;
